import { useSelector } from 'react-redux';

export function Error() {
  const { data } = useSelector((state) => state.validarUsuario);

  return (
    <section>
      <h1>{data.message}</h1>
    </section>
  );
}

export default Error;
